import { Component, Emit } from 'vue-property-decorator';
import { ControlPositionModel } from '../../types';
import ControlComponent from './control';

@Component
export default class BlindsComponent extends ControlComponent {

    @Emit()
    blindsMovementRequested(_controlPosition: ControlPositionModel) {
    }

    handleClick() {
        this.blindsMovementRequested(this.control);
    }
}
